import React from 'react';
import { useIntl } from 'react-intl';

import RhfTextField from './RhfTextField';
import RhfAutocomplete from './RhfAutocomplete';

import { FieldConfig, DataKey, Option } from 'pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/DialogAddGlobalAccount/types';

type Props = {
  field: FieldConfig;
  formContext: Record<DataKey, Option[]>;
  isEditMode: boolean;
};

// Config-driven adapter: maps a FieldConfig to the shared RHF field primitives.
const FormField = ({ field, formContext, isEditMode }: Props) => {
  const { formatMessage } = useIntl();
  const disabled = isEditMode && !field.editable;

  switch (field.type) {
    case 'text':
      return (
        <RhfTextField
          name={field.name}
          label={formatMessage(field.label)}
          required={field.required}
          autoFocus={field.autoFocus}
          disabled={disabled}
        />
      );

    case 'autocomplete':
      return (
        <RhfAutocomplete
          name={field.name}
          label={formatMessage(field.label)}
          options={formContext[field.optionsKey] ?? []}
          required={field.required}
          disabled={disabled}
          disableClearable={field.disableClearable}
        />
      );
  }
};

export default FormField;
